import PageLayout from '@/components/feature/PageLayout';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import DownloadSection from './components/DownloadSection';
import ReviewsSection from './components/ReviewsSection';
import FAQSection from './components/FAQSection';
import { useEffect } from 'react';

const homeSEO = {
  title: '皇冠App官方下载·正版安全体验 - 皇冠App官方网站',
  description: '皇冠App是深受用户信赖的移动应用平台，提供官方正版下载、安全稳定运行体验。本页详细介绍皇冠App的核心功能、下载安装步骤、常见问题解答及用户真实评价，帮助您快速上手皇冠App，享受流畅便捷的使用体验。',
  keywords: '皇冠App,皇冠App下载,皇冠App官方版,皇冠App安装教程,皇冠App最新版本,皇冠App使用指南,皇冠App安全认证',
  ogImage: 'https://readdy.ai/api/search-image?query=Huangguan%20App%20official%20website%20preview%20card%2C%20modern%20minimalist%20mobile%20app%20branding%2C%20warm%20golden%20accents%20on%20cream%20background%2C%20clean%20professional%20design%2C%20premium%20app%20showcase%2C%20sophisticated%20tech%20brand%20visual&width=1200&height=630&seq=home-og-2026&orientation=landscape',
};

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://huangguan.app/#organization',
      name: '皇冠App',
      url: 'https://huangguan.app',
      description: '皇冠App是深受用户信赖的移动应用平台，提供官方正版下载与安全运行体验。',
      logo: {
        '@type': 'ImageObject',
        url: 'https://huangguan.app/logo.png',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://huangguan.app/#website',
      url: 'https://huangguan.app',
      name: '皇冠App官方网站',
      inLanguage: 'zh-CN',
      publisher: { '@id': 'https://huangguan.app/#organization' },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://huangguan.app/#webpage',
      url: 'https://huangguan.app',
      name: '皇冠App官方下载·正版安全体验',
      isPartOf: { '@id': 'https://huangguan.app/#website' },
      about: { '@id': 'https://huangguan.app/#organization' },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Huangguan%20App%20official%20website%20preview%20card%2C%20modern%20minimalist%20mobile%20app%20branding%2C%20warm%20golden%20accents%20on%20cream%20background%2C%20clean%20professional%20design%2C%20premium%20app%20showcase%2C%20sophisticated%20tech%20brand%20visual&width=1200&height=630&seq=home-og-2026&orientation=landscape',
      },
      inLanguage: 'zh-CN',
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homepageJsonLd);
    script.id = 'schema-homepage';
    const existing = document.getElementById('schema-homepage');
    if (existing) existing.remove();
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-homepage');
      if (el) el.remove();
    };
  }, []);

  return (
    <PageLayout>
      <SEO {...homeSEO} canonicalUrl="https://huangguan.app" />
      <HeroSection />
      <FeaturesSection />
      <DownloadSection />
      <ReviewsSection />
      <FAQSection />
    </PageLayout>
  );
}